import { ref } from 'vue'
import { defineStore } from 'pinia'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

export const useAppStore = defineStore('app', () => {
  const isMobile = ref(false)
  const fingerId = ref('')

  const setIsMobile = (bol: boolean) => {
    isMobile.value = bol
  }

  const setFingerId = async () => {
    const fp = await FingerprintJS.load()
    const result = await fp.get()
    fingerId.value = result.visitorId
  }

  return { isMobile, setIsMobile, setFingerId, fingerId }
})
